import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './SessionExpiredModal.css';

export const SessionExpiredModal = ({ isOpen, isSessionConflict = false, onClose }) => {
    const { loginWithRedirect } = useAuth0();

    if (!isOpen) return null;

    const handleSignIn = () => {
        if (onClose) {
            onClose();
        }
        loginWithRedirect();
    };

    return (
        <div className="session-expired-modal-overlay">
            <div className="session-expired-modal">
                <h2>
                    {isSessionConflict ? 'Session Conflict Detected' : 'Session Expired'}
                </h2>
                <p>
                    {isSessionConflict 
                        ? 'Another session is active from a different location or device. For security reasons, please sign in again to continue.'
                        : 'Your session has expired. Please sign in again to continue.'
                    }
                </p>
                <button 
                    className="sign-in-button"
                    onClick={handleSignIn}
                >
                    Sign In
                </button>
            </div>
        </div>
    );
}; 